<template lang="pug">
    .box
        .path
            router-link(to='/' v-if="$route.path != '/'") 卫星发现·金融 >&nbsp;
            router-link(:to='$route.path') {{$route.name}}
        .right
            el-dropdown
                .login-out
                    el-avatar.avatar(:src="USER.AVATAR || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'")
                    .nickname(v-if="USER.NICKNAME") {{USER.NICKNAME}}
                el-dropdown-menu(slot="dropdown")
                    el-dropdown-item
                        router-link(to='/user')
                            i.el-icon-user
                            | 用户中心
                    el-dropdown-item
                        a(@click="logout")
                            i.el-icon-switch-button
                            | 登出
            //- router-link(to='/')
            //-     i.el-icon-bank-card
            router-link(to='/msg')
                el-badge(:value="USER.MSG" :hidden="!USER.MSG" class="item")
                    i.el-icon-message
            //- router-link(to='/login')
            //-     i.el-icon-s-tools
            Search.search

</template>

<script>
import storeMixin from '../store/mixin';
import Search from './stock-search.vue';

export default {
    name: 'Nav',
    mixins: [storeMixin],
    components: { Search },
    data() {
        return { keyword: '' };
    },
    async created() {
        await this.getInfo();
        this.getMsgCount();
        if (!this.USER.CELLPHONE && !window.localStorage.skipedBinding) {
            this.$confirm(
                '您尚未绑定手机，无法接收系统赠送的代金券，请问是否立即去绑定？(跳过后可自行在『用户中心』修改。)',
                '绑定手机',
                {
                    confirmButtonText: '立即去绑定',
                    cancelButtonText: '跳过',
                    type: 'warning',
                }
            )
                .then(() => {
                    this.$router.push('/user');
                })
                .catch(() => {
                    window.localStorage.skipedBinding = 1;
                });
        }
    },
    methods: {
        logout() {
            window.localStorage.user = '';
            this['USER/SET_STATE']({
                key: 'TOKEN',
                value: '',
            });
            this.$router.push('/login');
        },
        async getInfo() {
            const { data } = await this.REQUEST({
                url: 'v2/user/info',
            });
            const keys = Object.keys(data);
            const stateList = keys.map(key => {
                return {
                    key: key.toUpperCase(),
                    value: data[key],
                };
            });
            this['USER/SET_STATES'](stateList);
        },
        async getMsgCount() {
            const { data } = await this.REQUEST({
                url: 'v2/notification/list?limit=1',
            });
            this['USER/SET_STATE']({
                key: 'MSG',
                value: data.un_check,
            });
        },
    },
};
</script>

<style lang="stylus" scoped>
.box
    display flex
    justify-content space-between
    align-items center

.right
    display flex
    flex-direction row-reverse
    align-items center
    & > *
        margin-right 30px

    i
        font-size 28px
        color #767a8c
    .search
        width 200px
.login-out
    cursor pointer
.path
    a
        text-decoration underline
</style>
